<template>
  <div class="home">

      <h5>Dashboard</h5>

  </div>
</template>

<script>

import { store } from '@/store/store.js'

export default {
  name: 'home',
  store,
  components: {

  },
  data () {
    return {
      viewer : null
    }
  },
  created(){
    const self = this;
    // self.viewer = document.getElementById("stiDashboardsContainer");

  },
  mounted () {
    const self = this;

  },
  methods:{

  }
}
</script>
